export function mark(markName: string): void {
  if (window.performance && window.performance.mark) {
    window.performance.mark(markName);
  }
}

export function measure(
  measureName: string,
  startMark?: string,
  endMark?: string,
): void {
  if (window.performance && window.performance.measure) {
    window.performance.measure(measureName, startMark, endMark);
  }
}
